import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { URL_GLOBAL, URL_WEB } from 'src/environments/environment';
import { AuthService } from '../vos/auth.service';
@Injectable({
  providedIn: 'root'
})
export class PacienteService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }
  pegarListaDePacientesPorIdEmpresa(client_id?): Observable<Array<any>> {
    return this.http.get<Array<any>>(`${URL_GLOBAL}/web/gestaoOrcamentaria/pacientes/list?client_id=${client_id ? client_id : ''}`, { headers: this.authService.userToken() });
  }
  buscaPacientesDoConvenio(): Observable<Array<any>> {
    return this.http.get<Array<any>>(`${URL_GLOBAL}/web/pacientes/pacientesOfCliente`, { headers: this.authService.userToken() });
  }
  pegarPacientePorId(id): Observable<any> {
    return this.http.get<any>(`${URL_GLOBAL}/web/gestaoOrcamentaria/pacientes/${id}`, { headers: this.authService.userToken() });
  }
  salvarNovoPaciente(paciente): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/web/gestaoOrcamentaria/pacientes`, paciente, { headers: this.authService.userToken() });
  }
  atualizarPaciente(id, paciente, responsavel): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/web/gestaoOrcamentaria/pacientes/${id}/${responsavel}`, paciente, { headers: this.authService.userToken() });
  }
  desativarPaciente(id): Observable<any> {
    return this.http.delete<any>(`${URL_GLOBAL}/web/gestaoOrcamentaria/pacientes/${id}`, { headers: this.authService.userToken() });
  }

  // END POINT
  buscaPacientesDoConvenioNew(): Observable<Array<any>> {
    return this.http.get<Array<any>>(`${URL_GLOBAL}/web/pacientes/newpacientesOfCliente`, { headers: this.authService.userToken() });
  }

  verifyCpf(cpf): Observable<any> {
    return this.http.get<any>(`${URL_GLOBAL}/web/gestaoOrcamentaria/verifyCpfPatient?cpf=${cpf}`, { headers: this.authService.userToken() });
  }

  getDiagnosticsWithPaginate(url, description: string): Observable<any[]>{
    return this.http.get<any[]>(`${url ? url + '&paginate=1' :`${URL_WEB}/diagnostics-cid10-paginate?paginate=1`}&description=${description ? description : ''}`, { headers: this.authService.userToken() })
  }

  getDiagnostics(): Observable<any[]>{
    return this.http.get<any[]>(`${URL_WEB}/diagnostics-cid10`, { headers: this.authService.userToken() })
  }

  desactiveDiagnosticOfPatient(diagnostic_id): Observable<any>{
    return this.http.put<any>(`${URL_WEB}/desative-diagnostics-of-patient/${diagnostic_id}`, {} ,{ headers: this.authService.userToken() })
  }
}
